import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, H6, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { CreateAccount, DoNotAccount, EmailAddress, ForgotPassword, Href, Password, RememberPassword, SignIn, SignInAccount, SignInWith } from "../../utils/Constant";
import { useState } from "react";
import { toast } from "react-toastify";
import SocialApp from "./SocialApp";

const Login = () => {
    const [show, setShow] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const item = { email, password };
     let result;
    const SimpleLoginHandle = async(event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      result = await fetch("https://mobileapp.hemexhealth.org/login", {
        method: 'POST',
        body: JSON.stringify(item),
        headers: {
          "Content-Type": 'application/json',
          "Accept": 'application/json '
        }

      });
      result = await result.json();

      if (result.status == 0) {
        toast.error("Please Enter valid email or password...!");
      }
      else {
        const userRole = result.user.role;

        localStorage.setItem("login", JSON.stringify(true));
        localStorage.setItem("token", JSON.stringify(result.token));
        localStorage.setItem("userRole", (userRole));
        localStorage.setItem("email", (result.user.email));
        // localStorage.setItem("permissions", JSON.stringify(result.user.permissions));
        const permissionsResult = await fetch("https://mobileapp.hemexhealth.org/api/roles");
    const permissions = await permissionsResult.json();
    localStorage.setItem("permissions", JSON.stringify(permissions));

        if (permissions) {
          setTimeout(() => {
            navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
          }, 900);
        }
             }
            };
    
      // if (email === "test123@gmail.com" && password === "Test@123") {
      //   localStorage.setItem("login", JSON.stringify(true));
      //   navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
      // } else {
      //   toast.error("Please Enter valid email or password...!");
      // }
    // };
  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo text-center" to={Href}>
                  <Image className="img-fluid for-dark mx-auto" src={dynamicImage("logo/logo.png")} alt="looginpage" />
                  <Image className="img-fluid for-light mx-auto" src={dynamicImage("logo/logo_dark.png")} alt="looginpage" />
                </Link>
              </div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={(e) => SimpleLoginHandle(e)} >
                  <H4>{SignInAccount}</H4>
                  <P>{"Enter your email & password to login"}</P>
                  <FormGroup>
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input type="email" required placeholder="Test@gmail.com" value={email} name="email" onChange={(event) => setEmail(event.target.value)}  />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{Password}</Label>
                    <div className="form-input position-relative">
                      <Input type={show ? "text" : "password"} placeholder="*********"  onChange={(event) => setPassword(event.target.value)} value={password} name="password"/>
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span className="show"> </span>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-0 form-sub-title position-relative">
                    <div className="checkbox p-0">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" htmlFor="checkbox1">
                        {RememberPassword}
                      </Label>
                    </div>
                    <Link className="forgot-link" to={`${process.env.PUBLIC_URL}/authentication/forgetpassword`}  >
                      {ForgotPassword}
                    </Link>
                    <div className="text-end mt-3">
                      <Btn color="primary" block  className="w-100" >
                        {SignIn}
                      </Btn>
                    </div>
                  </FormGroup>
                  <H6 className="text-muted mt-4 or">{SignInWith}</H6>
                  <SocialApp />
                  <P className="mt-4 mb-0 text-center">
                    {DoNotAccount}
                    <Link className="ms-2" to={`${process.env.PUBLIC_URL}/authentication/registersimple`} >
                      {CreateAccount}
                    </Link>
                  </P>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
